// for debugging javascript!
(function(window){
    window.onerror = function(msg, url, ln, cn) {

        //transform errors
        if (typeof(msg) === 'object' && msg.srcElement && msg.target) {
            if(msg.srcElement === '[object HTMLScriptElement]' && msg.target === '[object HTMLScriptElement]'){
                msg = 'Error loading script';
            }else{
                msg = 'Event Error - target:' + msg.target + ' srcElement:' + msg.srcElement;
            }
        }

        msg = msg.toString();

        //ignore errors
        if(msg.indexOf("Location.toString") > -1){
            return;
        }
        if(msg.indexOf("Error loading script") > -1){
            return;
        }

        let message = encodeURIComponent(msg),
            scriptUrl = encodeURIComponent(url || document.location.toString().replace(/#.*$/, "")),
            lineNumber = parseInt(ln || 0),
            charNumber = parseInt(cn || 0);

        // report errors
        window.onerror = function(){};
        (new Image()).src = `/jserror?msg=${message}&url=${scriptUrl}&ln=${lineNumber}&cn=${charNumber}`;
    };
    // Call this function if you want to log js error manually
    window.logJsError = onerror;
})(window);



// WEBPACK FOOTER //
// ./js/utils/JsErrorLogging.js